<template>
	<v-card>
		<v-card-title>
			<h1 class="display-1">Pacientes</h1>
		</v-card-title>
		<v-card-text>
			<span v-if="idSolicitud == 0">
				<v-text-field
					v-model="nombre"
					label="Nombre"
					prepend-icon="mdi-account-box"
				/>
				<v-text-field
					v-model="primerApellido"
					label="Primer Apellido"
				/>
				<v-text-field
					v-model="segundoApellido"
					label="Segundo Apellido"
				/>
				<v-text-field
					v-model="fechaNacimiento"
					label="Fecha de Nacimiento"
					prepend-icon="mdi-calendar"
					readonly 
				></v-text-field>
				<v-date-picker
					v-model="fechaNacimiento"
					color="teal lighten-1"
					:max="new Date().toISOString().substr(0,10)"
					min="1930-01-01"
					@change="calculaEdad"
				></v-date-picker>
				<v-text-field
					v-model="edad"
					label="Edad"
				/>
				<v-combobox
					label="Sexo"
					v-model="sexo"
					:items="sexoLista"
					name="sexo"
					item-text="descripcion"
					item-value="idSexo"
				></v-combobox>
				<v-combobox
					label="Población"
					v-model="poblacion"
					:items="poblacionLista"
					name="poblacion"
					item-text="descripcion"
					item-value="idPoblacion"
				></v-combobox>
				<v-text-field
					v-model="telefono1"
					label="Teléfono 1"
					:counter="10"
					:rules="telefonoRules"
					prepend-icon="mdi-phone"
					hint="Primer medio de contacto"
				/>
				<v-text-field
					v-model="telefono2"
					label="Teléfono 2"
					:counter="10"
					:rules="telefonoRules"
					prepend-icon="mdi-cellphone"
					hint="Segundo medio de contacto"
				/>
				<v-text-field
					v-model="telefono3"
					label="Teléfono 3"
					:counter="10"
					:rules="telefonoRules"
					prepend-icon="mdi-cellphone"
					hint="Tercer medio de contacto"
				/>
				<Direccion @agrega-direccion="llenaDireccion"/>
		</span>
		<span v-if="idSolicitud != 0">
			<Solicitudes :idSolicitudCreada="idSolicitud" 
				:fechaSolicitudCreada="fechaSolicitud.toString().substr(0,10)"
			>
			</Solicitudes>
		</span>
		</v-card-text>
		<span v-if="idSolicitud == 0">
			<v-btn
				color="success"
				@click="enviaDatosPacientes"
			>
				Guardar
			</v-btn>
		</span>
	</v-card>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'
import Direccion from '@/components/Direccion'
import Solicitudes from '@/components/Solicitudes'
export default {
	components: {
		Direccion,
		Solicitudes
	},
	data() {
		return {
			idSolicitud: 0,
			fechaSolicitud: null,
			nombre: '',
			primerApellido: '',
			segundoApellido: '',
			fechaNacimiento: null, 
			idSexo: 0,
			sexo: '',
			sexoLista: [],
			idPoblacion: 0, 
			poblacion: '',
			poblacionLista: [],
			telefono1: '',
			telefono2: '',
			telefono3: '',
			edad: 0,
			respuesta: '',
			respuestaSolicitud: '',
			idCodigoPostal: 0,
			calleyNumero: '',
			idEntidad: 0,
			idMunicipio: 0,
			idColonia: 0,
			telefonoRules: [
				value => value.length <= 10 || "No debe exceder de 10 caracteres." 
			],
		}
	},
	created(){
		ServiciosApi.catalogosTodos(1)
			.then(response => {
				this.respuesta = response.data
				this.poblacionLista = this.respuesta.datos.poblacion
				this.sexoLista = this.respuesta.datos.sexo
			})
			.catch(error => {
				console.log("Hubieron errores", error.response)
			})
	},
	methods: {
		calculaEdad(fechaNacimiento) {
			var hoy = new Date()
			var fecNac = new Date(fechaNacimiento)
			var ed = hoy.getFullYear() - fecNac.getFullYear()
			var mes = hoy.getMonth() - fecNac.getMonth()
			if(mes < 0 || (mes === 0 && hoy.getDate() < fecNac.getDate())){
				ed--
			}
			this.edad = ed
		},
		llenaDireccion(direccion) {
			console.log(direccion)
			this.idCodigoPostal = direccion.idCodigoPostal
			this.calleyNumero = direccion.calleyNumero
			this.idEntidad = direccion.idEntidad
			this.idMunicipio = direccion.idMunicipio
			this.idColonia = direccion.idColonia
		},
		enviaDatosPacientes(){
			this.idSexo = this.sexo.idSexo
			this.idPoblacion = this.poblacion.idPoblacion
			let paciente = {
				nombre: this.nombre,
				primerApellido: this.primerApellido,
				segundoApellido: this.segundoApellido,
				fechaNacimiento: this.fechaNacimiento,
				edad: this.edad,
				idSexo: this.sexo.idSexo,
				idPoblacion: this.poblacion.idPoblacion,
				telefono1: this.telefono1,
				telefono2: this.telefono2,
				telefono3: this.telefono3,
				calleyNumero: this.calleyNumero,
				idCodigoPostal: this.idCodigoPostal,
				idEntidad: this.idEntidad,
				idMunicipio: this.idMunicipio,
				idColonia: this.idColonia
			}
			ServiciosApi.nuevaSolicitud(paciente)
				.then(response => {
					this.respuestaSolicitud = response.data
					if(this.respuestaSolicitud.status === 'ok'){
						console.log("Entramos a la verificación del status")
						this.idSolicitud = this.respuestaSolicitud.datos.idSolicitud
						this.fechaSolicitud = this.respuestaSolicitud.datos.fechaSolicitud
					}
				})
				.catch(error =>{
					console.log("Hubieron errores " + error.response)
				})
		}
	}
}
</script>
